

const FailureUrl = () => {
    return (
        <>
            <h1>success</h1>
        </>
    )
}


export { FailureUrl }